// Select all elements with the '.color-list a' selector
const elements = document.querySelectorAll('.color-list a');

// Attach a click event listener to each element
elements.forEach(element => {
  element.addEventListener('click', function(event) {
    event.preventDefault();
    // Get the value of the 'id' attribute of the clicked element
    const thisEl = this;
    changePreview(thisEl);
  });
});

elements.forEach(element => {
  element.addEventListener('mouseenter', function(event) {
    event.preventDefault();
    // Get the value of the 'id' attribute of the clicked element
    const thisEl = this;
    changePreview(thisEl);
  });
});

function changePreview(thisEl) {
  // Get the value of the 'id' attribute of the clicked element
  if(thisEl.classList.contains('active')){
    return false;
  }
  else {
    const color = thisEl.getAttribute('data-color');

    var parent = thisEl.closest('.grid__item'),
    currentlySelected = parent.querySelector('.color-list a.active');
    currentlySelected.classList.remove('active');
    thisEl.classList.add('active');

    var selectedText = parent.querySelector('.color-names span.active');
    textToChange = parent.querySelector('.color-names span.color-name-' + color);

    selectedText.classList.remove('active');
    textToChange.classList.add('active');

    var selectedImage = parent.querySelector('.card__media img.active'),
    imageToChange = parent.querySelector('.card__media img.color-' + color);

    selectedImage.classList.remove('active');
    imageToChange.classList.add('active');

    var variantID = thisEl.getAttribute('data-variant-id');

    var fullProductUrl = parent.querySelector('.full-unstyled-link').getAttribute('href');
    let searchParams = new URLSearchParams(fullProductUrl.split('?')[1]);
    
    // Remove the `variant` parameter
    searchParams.delete('variant');
    
    let origin = window.location.origin;
    
    // Rebuild the URL
    let newUrl = `${fullProductUrl.split('?')[0]}?${searchParams.toString()}` + 'variant=' + variantID;
    
    // Check if the URL starts with the origin
    if (!newUrl.startsWith(origin)) {
      // If the origin is not present at the start of the URL, add it using the `replace` method
      newUrl = newUrl.replace(/^/, origin);
    }
    parent.querySelector('.full-unstyled-link').setAttribute('href', newUrl );

    parent.setAttribute('data-href', newUrl );
    parent.classList.add('custom-link')


  }
}

const productLinks = document.querySelectorAll('.full-unstyled-link')
productLinks.forEach(element => {
  element.addEventListener('click', function(event) {
    var parent = this.closest('.grid__item');
    console.log('link clicked')
    console.log(this)
    if(parent.classList.contains('custom-link')) {
      console.log('contains link class')
      event.preventDefault();
      
      window.location = parent.getAttribute('data-href');
    }
    else {
      console.log('did not contain that class')
    }
  });
});


